import './vendor.js';
import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import solid from '@fortawesome/fontawesome-free-solid';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all';

import noUiSlider from 'nouislider';

import 'cookieconsent';

import wNumb from './wnumb-1.1.0/wNumb';

import 'sticky-kit/dist/sticky-kit.min.js';

fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	//radio js vor checked
	function setSalutationState(){
	    $('.complex-form-gender-fm input, .complex-form-gender-m input').each(function(key, elem){
	        if (elem.checked) {
	            $(elem).closest('div').addClass('checked');
	        } else {
	            $(elem).closest('div').removeClass('checked');
	        }
	    });
	}


    function setRadioBtnsPlease(){
		$(".complex-contact-form .radio label").each(function(index, elem){
    		var isChecked = $(elem).find("input[type='radio']").is(":checked");
	    	if (isChecked) {
	    		$(".complex-contact-form .radio label").removeClass("checked");
	    		$(elem).addClass("checked");
	    	} else {
	    		$(".complex-contact-form .radio label").addClass("checked");
	    		$(elem).removeClass("checked");
	    	}
    	});
	}

	function round(value, exp) {
	  if (typeof exp === 'undefined' || +exp === 0)
	    return Math.round(value);

	  value = +value;
	  exp = +exp;

	  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
	    return NaN;

	  // Shift
	  value = value.toString().split('e');
	  value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

	  // Shift back
	  value = value.toString().split('e');
	  return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
	}

	function number_format (number, decimals, dec_point, thousands_sep) {
	    // Strip all characters but numerical ones.
	    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	    var n = !isFinite(+number) ? 0 : +number,
	        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
	        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
	        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
	        s = '',
	        toFixedFix = function (n, prec) {
	            var k = Math.pow(10, prec);
	            return '' + Math.round(n * k) / k;
	        };
	    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
	    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
	    if (s[0].length > 3) {
	        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	    }
	    if ((s[1] || '').length < prec) {
	        s[1] = s[1] || '';
	        s[1] += new Array(prec - s[1].length + 1).join('0');
	    }
	    return s.join(dec);
	}

	function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}

	$('.gallery').lightGallery({
		selector: '.gallery-item a'
	});

	if ($(".sticky-col .contentInner").length) {
		$(".sticky-col .contentInner").stick_in_parent({offset_top: $('#header').outerHeight()});
	}

	if ($('.replace-form').length) {
		$('#complexContactFormAnchor').replaceWith($('.wpforms-container'));
		$('.complex-call-contact-form').on('click', function(){
			setTimeout(function(){
				var jsonData = $('.complex-contact-form-wrapper').parent().parent().parent().prev().data('json');
				var jsonArray = [];
				jsonArray.push(jsonData);
				$.each(jsonArray, function(){
					console.log(jsonArray[0].name);
					$('.wpforms-field-hidden input').val(jsonArray[0].name);
				});
			}, 500)
		});
		
	} else if ($('.replace-form-iframe').length) {
		$('#complexContactFormAnchor').replaceWith($('.iframe-contactform'));	    	
	}

	if ($('.form-calculator').length) {
		$('.checker-field input, .wpf-disable-field input').attr('tabindex', '-1');
		$('.form-calculator input').on('change', function(){
			var ageMonsieur = $('.age-monsieur input').val() != '' ? $('.age-monsieur input').val() : 0;

			var ageMadame = $('.age-madame input').val() != '' ? $('.age-madame input').val() : 0;

			var cash = $('.cash input').val() != '' ? $('.cash input').val() : 0;
			if (!isNumeric(cash)) {
				cash = cash.replace(/\'/g, '');
			}
			
			var troisPilier = $('.trois-pilier input').val() != '' ? $('.trois-pilier input').val() : 0;
			if (!isNumeric(troisPilier)) {
				troisPilier = troisPilier.replace(/\'/g, '');
			}

			var deuxPilier = $('.deux-pilier input').val() != '' ? $('.deux-pilier input').val() : 0;
			if (!isNumeric(deuxPilier)) {
				deuxPilier = deuxPilier.replace(/\'/g, '');
			}

			var nanPilier = $('.nan-pilier input').val() != '' ? $('.nan-pilier input').val() : 0;
			if (!isNumeric(nanPilier)) {
				nanPilier = nanPilier.replace(/\'/g, '');
			}

			var prixAchat = $('.prix-achat input').val() != '' ? $('.prix-achat input').val() : 0;
			if (!isNumeric(prixAchat)) {
				prixAchat = prixAchat.replace(/\'/g, '');
			}

			var tauxAvance = parseFloat((1 - ((parseFloat(cash) + parseFloat(troisPilier) + parseFloat(deuxPilier) + parseFloat(nanPilier)) / parseFloat(prixAchat))) * 100);
			$('.taux-avance input').val(round(tauxAvance, 1) + '%');

			var ph = parseFloat(parseFloat(prixAchat) - parseFloat(cash) - parseFloat(troisPilier) - parseFloat(deuxPilier));
			$('.ph input').val(number_format(ph, 0, '.', '\''));

			var ageCalcMonsieur = '';
			if ($('.age-monsieur input').val() != '') {
				if (parseFloat(ageMonsieur) >= 65) {
					ageCalcMonsieur = 1;
				} else {
					ageCalcMonsieur = 65 - parseFloat(ageMonsieur);
				}
			}

			var ageCalcMadame = '';
			if ($('.age-madame input').val() != '') {
				if (parseFloat(ageMadame) >= 64) {
					ageCalcMadame = 1;
				} else {
					ageCalcMadame = 64 - parseFloat(ageMadame);
				}
			}

			var ageCalc = '';
			if (parseFloat(ageCalcMonsieur) < parseFloat(ageCalcMadame)) {
				ageCalc = ageCalcMonsieur;
			} else {
				ageCalc = ageCalcMadame;
			}

			var ageCalcFonds = '';

			if (parseFloat(ageCalc) >= 15) {
				ageCalcFonds = (((parseFloat(ph) - parseFloat(nanPilier)) - (2 / 3) * parseFloat(prixAchat)) / 15);
			} else {
				ageCalcFonds = (((parseFloat(ph) - parseFloat(nanPilier)) - (2 / 3) * parseFloat(prixAchat)) / parseFloat(ageCalc));
			}

			if ((parseFloat(cash) + parseFloat(troisPilier) + parseFloat(nanPilier)) >= 0.1 * parseFloat(prixAchat) && parseFloat(prixAchat) > 0) {
				$('.upper-field-checker input').val('Fonds propres dures OK');
				$('.upper-field-checker input').addClass('upper-field-checker--green');
			} else {
				$('.upper-field-checker input').val('Merci d\'augmenter les fonds propres');
				if ($('.upper-field-checker input').hasClass('upper-field-checker--green')) {
					$('.upper-field-checker input').removeClass('upper-field-checker--green');
				}
			}

			if ((parseFloat(ageMonsieur) >= 65 && parseFloat(tauxAvance) > 66.6) || (parseFloat(ageMadame) >= 65 && parseFloat(tauxAvance) > 66.6)) {
				$('.age-checker input').val('Ajouter des fonds propres');
				$('.age-checker input').addClass('age-checker--red');
			} else {
				$('.age-checker input').val('OK');
				if ($('.age-checker input').hasClass('age-checker--red')) {
					$('.age-checker input').removeClass('age-checker--red');
				}
			}

			if (parseFloat(tauxAvance) > 80) {
				$('.taux-checker input').val('Augmenter les fonds propres');
				$('.taux-checker input').addClass('taux-checker--red');
			} else {
				$('.taux-checker input').val('OK');
				if ($('.taux-checker input').hasClass('taux-checker--red')) {
					$('.taux-checker input').removeClass('taux-checker--red');
				}
			}

			var tauxTheorique = $('.taux-theorique input').val();
			tauxTheorique = tauxTheorique.replace('%', '');
			tauxTheorique = parseFloat(tauxTheorique) / 100;
			var tauxTheoriqueCalc = parseFloat(ph) * parseFloat(tauxTheorique);
			$('.taux-theorique-calc input').val(number_format(tauxTheoriqueCalc, 0, '.', '\''));

			var amortissementCalc = '';

			if (parseFloat(ageCalcFonds) > 0) {
				amortissementCalc = ageCalcFonds;
			} else {
				amortissementCalc = 0;
			}
			$('.amortissement-calc input').val(number_format(amortissementCalc, 0, '.', '\''));

			var chargesEntretien = $('.charges-entretien input').val();
			chargesEntretien = chargesEntretien.replace('%', '');
			chargesEntretien = parseFloat(chargesEntretien) / 100;
			var chargesEntretienCalc = parseFloat(prixAchat) * parseFloat(chargesEntretien);
			$('.charges-entretien-calc input').val(number_format(chargesEntretienCalc, 0, '.', '\''));

			var valeurFiscaleOne = $('.valeur-fiscale-one input').val() != '' ? $('.valeur-fiscale-one input').val() : 0;
			if (!isNumeric(valeurFiscaleOne)) {
				valeurFiscaleOne = valeurFiscaleOne.replace(/\'/g, '');
			}

			var detteHypothecaireOne = $('.dette-hypothecaire-one input').val() != '' ? $('.dette-hypothecaire-one input').val() : 0;
			if (!isNumeric(detteHypothecaireOne)) {
				detteHypothecaireOne = detteHypothecaireOne.replace(/\'/g, '');
			}

			var revenuLocatifOne = $('.revenu-locatif-one input').val() != '' ? $('.revenu-locatif-one input').val() : 0;
			if (!isNumeric(revenuLocatifOne)) {
				revenuLocatifOne = revenuLocatifOne.replace(/\'/g, '');
			}

			var valeurFiscaleTwo = $('.valeur-fiscale-two input').val() != '' ? $('.valeur-fiscale-two input').val() : 0;
			if (!isNumeric(valeurFiscaleTwo)) {
				valeurFiscaleTwo = valeurFiscaleTwo.replace(/\'/g, '');
			}

			var detteHypothecaireTwo = $('.dette-hypothecaire-two input').val() != '' ? $('.dette-hypothecaire-two input').val() : 0;
			if (!isNumeric(detteHypothecaireTwo)) {
				detteHypothecaireTwo = detteHypothecaireTwo.replace(/\'/g, '');
			}

			var revenuLocatifTwo = $('.revenu-locatif-two input').val() != '' ? $('.revenu-locatif-two input').val() : 0;
			if (!isNumeric(revenuLocatifTwo)) {
				revenuLocatifTwo = revenuLocatifTwo.replace(/\'/g, '');
			}

			var amortissementOne = parseFloat(detteHypothecaireOne) - 0.66 * parseFloat(valeurFiscaleOne);
			var amortissementTwo = parseFloat(detteHypothecaireTwo) - 0.66 * parseFloat(valeurFiscaleTwo);

			var checkAmortissementOne = '';
			if (parseFloat(amortissementOne) < 0) {
				checkAmortissementOne = 0;
			} else {
				checkAmortissementOne = parseFloat(amortissementOne) / 15;
			}

			var checkAmortissementTwo = '';
			if (parseFloat(amortissementTwo) < 0) {
				checkAmortissementTwo = 0;
			} else {
				checkAmortissementTwo = parseFloat(amortissementTwo) / 15;
			}

			var gainLocatifOne = '';
			if (parseFloat(revenuLocatifOne) - (0.01 * parseFloat(valeurFiscaleOne) + parseFloat(checkAmortissementOne) + 0.05 * parseFloat(detteHypothecaireOne)) < 0) {
				gainLocatifOne = 0;
			} else {
				gainLocatifOne = parseFloat(revenuLocatifOne) - (0.01 * parseFloat(valeurFiscaleOne) + parseFloat(checkAmortissementOne) + 0.05 * parseFloat(detteHypothecaireOne));
			}
			$('.gain-locatif-one input').val(number_format(gainLocatifOne, 0, '.', '\''));

			var gainLocatifTwo = '';
			if (parseFloat(revenuLocatifTwo) - (0.01 * parseFloat(valeurFiscaleTwo) + parseFloat(checkAmortissementTwo) + 0.05 * parseFloat(detteHypothecaireTwo)) < 0) {
				gainLocatifTwo = 0;
			} else {
				gainLocatifTwo = parseFloat(revenuLocatifTwo) - (0.01 * parseFloat(valeurFiscaleTwo) + parseFloat(checkAmortissementTwo) + 0.05 * parseFloat(detteHypothecaireTwo));
			}
			$('.gain-locatif-two input').val(number_format(gainLocatifTwo, 0, '.', '\''));

			var mancoLocatifOne = '';
			if (parseFloat(revenuLocatifOne) - (0.01 * parseFloat(valeurFiscaleOne) + parseFloat(checkAmortissementOne) + 0.05 * parseFloat(detteHypothecaireOne)) < 0) {
				mancoLocatifOne = parseFloat(revenuLocatifOne) - (0.01 * parseFloat(valeurFiscaleOne) + parseFloat(checkAmortissementOne) + 0.05 * parseFloat(detteHypothecaireOne));
			} else {
				mancoLocatifOne = 0;
			}
			$('.manco-locatif-one input').val(number_format(mancoLocatifOne, 0, '.', '\''));

			var mancoLocatifTwo = '';
			if (parseFloat(revenuLocatifTwo) - (0.01 * parseFloat(valeurFiscaleTwo) + parseFloat(checkAmortissementTwo) + 0.05 * parseFloat(detteHypothecaireTwo)) < 0) {
				mancoLocatifTwo = parseFloat(revenuLocatifTwo) - (0.01 * parseFloat(valeurFiscaleTwo) + parseFloat(checkAmortissementTwo) + 0.05 * parseFloat(detteHypothecaireTwo));
			} else {
				mancoLocatifTwo = 0;
			}
			$('.manco-locatif-two input').val(number_format(mancoLocatifTwo, 0, '.', '\''));

			var checkRevenuLocatif = '';
			if (parseFloat(revenuLocatifOne) + parseFloat(revenuLocatifTwo) == 0) {
				checkRevenuLocatif = 1;
			} else {
				checkRevenuLocatif = 0;
			}

			var checkMancoLocatif = '';
			if (parseFloat(revenuLocatifOne) + parseFloat(revenuLocatifTwo) == 0) {
				checkMancoLocatif = 1;
			} else {
				checkMancoLocatif = 0;
			}


			var salaireBrutMr = $('.salaire-brut-mr input').val() != '' ? $('.salaire-brut-mr input').val() : 0;
			if (!isNumeric(salaireBrutMr)) {
				salaireBrutMr = salaireBrutMr.replace(/\'/g, '');
			}

			var salaireBrutMme = $('.salaire-brut-mme input').val() != '' ? $('.salaire-brut-mme input').val() : 0;
			if (!isNumeric(salaireBrutMme)) {
				salaireBrutMme = salaireBrutMme.replace(/\'/g, '');
			}

			var bonusMr = $('.bonus-mr input').val() != '' ? $('.bonus-mr input').val() : 0;
			if (!isNumeric(bonusMr)) {
				bonusMr = bonusMr.replace(/\'/g, '');
			}

			var bonusMme = $('.bonus-mme input').val() != '' ? $('.bonus-mme input').val() : 0;
			if (!isNumeric(bonusMme)) {
				bonusMme = bonusMme.replace(/\'/g, '');
			}

			var allocationsFamilialesMr = $('.allocations-familiales-mr input').val() != '' ? $('.allocations-familiales-mr input').val() : 0;
			if (!isNumeric(allocationsFamilialesMr)) {
				allocationsFamilialesMr = allocationsFamilialesMr.replace(/\'/g, '');
			}

			var allocationsFamilialesMme = $('.allocations-familiales-mme input').val() != '' ? $('.allocations-familiales-mme input').val() : 0;
			if (!isNumeric(allocationsFamilialesMme)) {
				allocationsFamilialesMme = allocationsFamilialesMme.replace(/\'/g, '');
			}

			var pensionRecuMr = $('.pension-recu-mr input').val() != '' ? $('.pension-recu-mr input').val() : 0;
			if (!isNumeric(pensionRecuMr)) {
				pensionRecuMr = pensionRecuMr.replace(/\'/g, '');
			}

			var pensionRecuMme = $('.pension-recu-mme input').val() != '' ? $('.pension-recu-mme input').val() : 0;
			if (!isNumeric(pensionRecuMme)) {
				pensionRecuMme = pensionRecuMme.replace(/\'/g, '');
			}

			var pensionVerseeMr = $('.pension-versee-mr input').val() != '' ? $('.pension-versee-mr input').val() : 0;
			if (!isNumeric(pensionVerseeMr)) {
				pensionVerseeMr = pensionVerseeMr.replace(/\'/g, '');
			}

			var pensionVerseeMme = $('.pension-versee-mme input').val() != '' ? $('.pension-versee-mme input').val() : 0;
			if (!isNumeric(pensionVerseeMme)) {
				pensionVerseeMme = pensionVerseeMme.replace(/\'/g, '');
			}

			var leasingMr = $('.leasing-mr input').val() != '' ? $('.leasing-mr input').val() : 0;
			if (!isNumeric(leasingMr)) {
				leasingMr = leasingMr.replace(/\'/g, '');
			}

			var leasingMme = $('.leasing-mme input').val() != '' ? $('.leasing-mme input').val() : 0;
			if (!isNumeric(leasingMme)) {
				leasingMme = leasingMme.replace(/\'/g, '');
			}

			var revenuTotaux = parseFloat(salaireBrutMr) + 0.5 * parseFloat(bonusMr) + parseFloat(salaireBrutMme) + 0.5 * parseFloat(bonusMme) + parseFloat(allocationsFamilialesMr) + parseFloat(allocationsFamilialesMme) - parseFloat(leasingMr) - parseFloat(leasingMme) + parseFloat(pensionRecuMr) + parseFloat(pensionRecuMme) - parseFloat(pensionVerseeMr) - parseFloat(pensionVerseeMme) + parseFloat(gainLocatifOne) + parseFloat(gainLocatifTwo);
			$('.revenu-totaux input').val(number_format(revenuTotaux, 0, '.', '\''));

			var checkRevenuTotaux = '';
			if (parseFloat(revenuTotaux) < 100000) {
				checkRevenuTotaux = 0;
			} else {
				checkRevenuTotaux = 1;
			}


			var totalCharges = parseFloat(tauxTheoriqueCalc) + parseFloat(amortissementCalc) + parseFloat(chargesEntretienCalc) - parseFloat(mancoLocatifOne) - parseFloat(mancoLocatifTwo);
			$('.total-charges input').val(number_format(totalCharges, 0, '.', '\''));

			var helpRatioCharge = parseFloat(totalCharges) / parseFloat(revenuTotaux);

			var helpRatioDefault = '';
			if (parseFloat(tauxAvance) < 67 && parseFloat(tauxAvance) >= 0) {
				helpRatioDefault = 39.1;
			} else {
				helpRatioDefault = 0;
			}

			var helpRatioOne = '';
			if (parseFloat(tauxAvance) < 100 && parseFloat(tauxAvance) >= 79) {
				helpRatioOne = 33.34;
			} else {
				helpRatioOne = 0;
			}

			var helpRatioTwo = '';
			if (parseFloat(tauxAvance) < 79 && parseFloat(tauxAvance) >= 78) {
				helpRatioTwo = 33.8;
			} else {
				helpRatioTwo = 0;
			}

			var helpRatioThree = '';
			if (parseFloat(tauxAvance) < 78 && parseFloat(tauxAvance) >= 77) {
				helpRatioThree = 34.2;
			} else {
				helpRatioThree = 0;
			}

			var helpRatioFour = '';
			if (parseFloat(tauxAvance) < 77 && parseFloat(tauxAvance) >= 76) {
				helpRatioFour = 34.6;
			} else {
				helpRatioFour = 0;
			}

			var helpRatioFive = '';
			if (parseFloat(tauxAvance) < 76 && parseFloat(tauxAvance) >= 75) {
				helpRatioFive = 35.1;
			} else {
				helpRatioFive = 0;
			}

			var helpRatioSix = '';
			if (parseFloat(tauxAvance) < 75 && parseFloat(tauxAvance) >= 74) {
				helpRatioSix = 35.5;
			} else {
				helpRatioSix = 0;
			}

			var helpRatioSeven = '';
			if (parseFloat(tauxAvance) < 74 && parseFloat(tauxAvance) >= 73) {
				helpRatioSeven = 35.9;
			} else {
				helpRatioSeven = 0;
			}

			var helpRatioEight = '';
			if (parseFloat(tauxAvance) < 73 && parseFloat(tauxAvance) >= 72) {
				helpRatioEight = 36.3;
			} else {
				helpRatioEight = 0;
			}

			var helpRatioNine = '';
			if (parseFloat(tauxAvance) < 72 && parseFloat(tauxAvance) >= 71) {
				helpRatioNine = 36.8;
			} else {
				helpRatioNine = 0;
			}

			var helpRatioTen = '';
			if (parseFloat(tauxAvance) < 71 && parseFloat(tauxAvance) >= 70) {
				helpRatioTen = 37.2;
			} else {
				helpRatioTen = 0;
			}

			var helpRatioEleven = '';
			if (parseFloat(tauxAvance) < 70 && parseFloat(tauxAvance) >= 69) {
				helpRatioEleven = 37.7;
			} else {
				helpRatioEleven = 0;
			}

			var helpRatioTwelve = '';
			if (parseFloat(tauxAvance) < 69 && parseFloat(tauxAvance) >= 68) {
				helpRatioTwelve = 38.1;
			} else {
				helpRatioTwelve = 0;
			}

			var helpRatioThirteen = '';
			if (parseFloat(tauxAvance) < 68 && parseFloat(tauxAvance) >= 67) {
				helpRatioThirteen = 38.6;
			} else {
				helpRatioThirteen = 0;
			}

			var sumHelpRatios = parseFloat(helpRatioOne) + parseFloat(helpRatioTwo) + parseFloat(helpRatioThree) + parseFloat(helpRatioFour) + parseFloat(helpRatioFive) + parseFloat(helpRatioSix) + parseFloat(helpRatioSeven) + parseFloat(helpRatioEight) + parseFloat(helpRatioNine) + parseFloat(helpRatioTen) + parseFloat(helpRatioEleven) + parseFloat(helpRatioTwelve) + parseFloat(helpRatioThirteen) + parseFloat(helpRatioDefault); 

			var checkTotalCharge = '';
			if (parseFloat(helpRatioCharge) < parseFloat(sumHelpRatios)) {
				checkTotalCharge = 1;
			} else {
				checkTotalCharge = 0;
			}

			var checkSum = parseFloat(checkTotalCharge) + parseFloat(checkMancoLocatif) + parseFloat(checkRevenuTotaux) + parseFloat(checkRevenuLocatif);

			var ratioCharge = '';
			if (parseFloat(checkSum) == 4) {
				ratioCharge = helpRatioCharge * 100;
			} else {
				ratioCharge = (parseFloat(helpRatioCharge) + 0.0001) * 100;
			}
			$('.ratio-charge input').val(round(ratioCharge, 2) + '%');
			if(round(ratioCharge, 2) > 33.33){
				if($('.ratio-charge input').hasClass('green-input')){
					$('.ratio-charge input').removeClass('green-input');
				}
				$('.ratio-charge input').addClass('red-input');
			} else {
				if($('.ratio-charge input').hasClass('red-input')){
					$('.ratio-charge input').removeClass('red-input');
				}
				$('.ratio-charge input').addClass('green-input');
			}

		});
	}

	$(document).on("keydown", ":input:not(textarea)", function(event) {
		if (event.key == "Enter") {
			event.preventDefault();
		}
	});

	$('.bannerKachelWrap').addClass('fadeIn');

	if ($('.bannerKachelWrap').find('.wholeLink')) {
		$('.bannerKachelWrap .wholeLink').each(function(index, el){
			$(el).parent().parent().addClass('kachelHover');
		});
	}

	setRadioBtnsPlease();
	$(".complex-contact-form .radio label").on('click', function(){
		setRadioBtnsPlease();
	})

	$('.complex-form-gender-fm input, .complex-form-gender-m input').on('change', function(){
		setSalutationState();
	});
	setSalutationState();

	$('.complex-download-btn').attr("onclick", "ga(\'send\', \'event\', \'Plan\');");

	$('.complex-call-contact-form').attr("onclick", "ga(\'send\', \'event\', \'Form\');");

	$('.navbar-toggler').on('click', function(){
		if ($(this).hasClass('active-nav')) {
			$(this).removeClass('active-nav');
			$('.navbarOuter').removeClass('nav-bg');
		} else {
			$(this).addClass('active-nav');
			$('.navbarOuter').addClass('nav-bg');
		}
	});

	$('.navbar-collapse').on('shown.bs.collapse', function(){
		$('#footer').hide();
		$('#content').hide();
		$('.sliderOuter').hide();
		$('#header').css('position', 'absolute');
	});

	$('.navbar-collapse').on('show.bs.collapse', function(){
		$('html, body').animate({
			scrollTop: $('html, body').offset().top
		}, 500);
	});

	$('.navbar-collapse').on('hidden.bs.collapse', function(){
	});

	$('.navbar-collapse').on('hide.bs.collapse', function(){
		$('#header').css('position', 'fixed');
		$('#footer').show();
		$('#content').show();
		$('.sliderOuter').show();
	});

	//mobile header nav click toggles also
	$('.navbar-header').on('click', function(event) {
		if ($(event.target).hasClass('navbar-header') || $(event.target).hasClass('navbar-brand')) {
			$(this).find('.navbar-toggle').trigger('click');
		}
	});

	//module slider flickity
	if ($('.slider').length) {
		var flky = new Flickity( '.slider', {
			cellAlign: 'center',
			wrapAround: true,
			imagesLoaded: true,
			pageDots: false,
			prevNextButtons: true,
			autoPlay: 7000,
			arrowShape: 'M30.4852814,53 L45.363961,67.8786797 C46.5355339,69.0502525 46.5355339,70.9497475 45.363961,72.1213203 C44.1923882,73.2928932 42.2928932,73.2928932 41.1213203,72.1213203 L19,50 L41.1213203,27.8786797 C42.2928932,26.7071068 44.1923882,26.7071068 45.363961,27.8786797 C46.5355339,29.0502525 46.5355339,30.9497475 45.363961,32.1213203 L30.4852814,47 L78,47 C79.6568542,47 81,48.3431458 81,50 C81,51.6568542 79.6568542,53 78,53 L30.4852814,53 Z'
		});
		$('.flickity-prev-next-button').wrapAll('<div class="container"></div>');
	}

	var rangeFlaeche = document.getElementById('filteroption-flaeche');
		var inputFlaecheFrom = document.getElementById('livingspace_from');
		var inputFlaecheTo = document.getElementById('livingspace_to');

		if (inputFlaecheFrom) {
			if (inputFlaecheFrom.value !== '' && parseFloat(inputFlaecheFrom.value) !== Math.floor(parseFloat(inputFlaecheFrom.value))) {
				inputFlaecheFrom.value = Math.floor(parseFloat(inputFlaecheFrom.value));
			}
		}
		if (inputFlaecheTo) {
			if (inputFlaecheTo.value !== '' && parseFloat(inputFlaecheTo.value) !== Math.ceil(parseFloat(inputFlaecheTo.value))) {
				inputFlaecheTo.value = Math.ceil(parseFloat(inputFlaecheTo.value));
			}
		}


		//Wohnfläche Nouislider
		if (rangeFlaeche) {
			$('#livingspace_from').css('display', 'none');
			$('#livingspace_to').css('display', 'none');
			var sliderFlaecheMin = document.getElementById('filteroption-flaeche');
			var MinValueFlaeche = sliderFlaecheMin.getAttribute('data-minlivingspace');
			var MaxValueFlaeche = sliderFlaecheMin.getAttribute('data-maxlivingspace');
			var MinValueFlaeche = Math.round(Number(MinValueFlaeche));
			var MaxValueFlaeche = Math.round(Number(MaxValueFlaeche));

			if (MinValueFlaeche  == MaxValueFlaeche){
			MaxValueFlaeche = MinValueFlaeche + 1;
			}

			noUiSlider.create(rangeFlaeche, {
				start: [ MinValueFlaeche, MaxValueFlaeche ],
				step: 1, // Slider moves in increments of '10'
				margin: 1, // Handles must be more than '20' apart
				connect: true, // Display a colored bar between the handles
				direction: 'ltr', // Put '0' at the bottom of the slider
				orientation: 'horizontal', // Orient the slider vertically
				behaviour: 'tap-drag', // Move handle on tap, bar is draggable
				range: { // Slider can select '0' to '100'
					'min': MinValueFlaeche,
					'max': MaxValueFlaeche
				},
				format: {
					to: function ( value ) {
					return Math.round(value);
					},
					from: function ( value ) {
						return Math.round(value);
					}
				}
			});

			var flaecheSliderValues = [
				document.getElementById('flaeche-slider-lower-value'),
				document.getElementById('flaeche-slider-upper-value')
			];

			flaecheSliderValues[0].innerHTML = Math.round(MinValueFlaeche);
			flaecheSliderValues[1].innerHTML = Math.round(MaxValueFlaeche);

			rangeFlaeche.noUiSlider.on('update', function( values, handle ) {
				flaecheSliderValues[handle].innerHTML = Math.round(values[handle]);
			});

			rangeFlaeche.noUiSlider.on('change', function( values, handle ) {
				var value = values[handle];
				
				if ( handle ) {
					inputFlaecheTo.value = Math.round(value);
				} else {
					inputFlaecheFrom.value = Math.round(value);
				}
				$('#complexFilterForm').trigger('change');
			});

			inputFlaecheFrom.addEventListener('change', function(){
				rangeFlaeche.noUiSlider.set([Math.round(this.value), null]);
			});

			inputFlaecheTo.addEventListener('change', function(){
				rangeFlaeche.noUiSlider.set([null, Math.round(this.value)]);
			});
		}

		//Kaufpreis Nouislider
		var rangeKaufpreis = document.getElementById('filteroption-purchase-price');
		var inputKaufpreisFrom = document.getElementById('purchaseprice_from');
		var inputKaufpreisTo = document.getElementById('purchaseprice_to');

		if (inputKaufpreisFrom) {
			if (inputKaufpreisFrom.value !== '' && parseFloat(inputKaufpreisFrom.value) !== Math.floor(parseFloat(inputKaufpreisFrom.value))) {
				inputKaufpreisFrom.value = Math.floor(parseFloat(inputKaufpreisFrom.value));
			}
		}
		if (inputKaufpreisTo) {
			if (inputKaufpreisTo.value !== '' && parseFloat(inputKaufpreisTo.value) !== Math.ceil(parseFloat(inputKaufpreisTo.value))) {
				inputKaufpreisTo.value = Math.ceil(parseFloat(inputKaufpreisTo.value));
			}
		}
		
		if (rangeKaufpreis) {
			$('#purchaseprice_from').css('display', 'none');
			$('#purchaseprice_to').css('display', 'none');
			var sliderKaufpreisMin = document.getElementById('filteroption-purchase-price');
			var MinValueKaufpreis = sliderKaufpreisMin.getAttribute('data-minpurchaseprice');
			var MaxValueKaufpreis = sliderKaufpreisMin.getAttribute('data-maxpurchaseprice');
			var MinValueKaufpreis = Math.round(Number(MinValueKaufpreis));
			var MaxValueKaufpreis = Math.round(Number(MaxValueKaufpreis));

			if (MinValueKaufpreis  == MaxValueKaufpreis){
			MaxValueKaufpreis = MinValueKaufpreis + 1;
			}

			noUiSlider.create(rangeKaufpreis, {
				start: [ MinValueKaufpreis, MaxValueKaufpreis ],
				step: 1, // Slider moves in increments of '10'
				margin: 1, // Handles must be more than '20' apart
				connect: true, // Display a colored bar between the handles
				direction: 'ltr', // Put '0' at the bottom of the slider
				orientation: 'horizontal', // Orient the slider vertically
				behaviour: 'tap-drag', // Move handle on tap, bar is draggable
				range: { // Slider can select '0' to '100'
					'min': MinValueKaufpreis,
					'max': MaxValueKaufpreis
				},
				format: {
					to: function ( value ) {
					return Math.round(value);
					},
					from: function ( value ) {
						return Math.round(value);
					}
				}
			});

			var kaufSliderValues = [
				document.getElementById('kauf-slider-lower-value'),
				document.getElementById('kauf-slider-upper-value')
			];

			kaufSliderValues[0].innerHTML = number_format(MinValueKaufpreis, 0, '.', '\'');
			kaufSliderValues[1].innerHTML = number_format(MaxValueKaufpreis, 0, '.', '\'');

			rangeKaufpreis.noUiSlider.on('update', function( values, handle ) {
				kaufSliderValues[handle].innerHTML = number_format(values[handle], 0, '.', '\'');
			});

			rangeKaufpreis.noUiSlider.on('change', function( values, handle ) {
				var value = values[handle];
				
				if ( handle ) {
					inputKaufpreisTo.value = Math.round(value);
				} else {
					inputKaufpreisFrom.value = Math.round(value);
				}
				$('#complexFilterForm').trigger('change');
			});

			inputKaufpreisFrom.addEventListener('change', function(){
				rangeKaufpreis.noUiSlider.set([Math.round(this.value), null]);
			});

			inputKaufpreisTo.addEventListener('change', function(){
				rangeKaufpreis.noUiSlider.set([null, Math.round(this.value)]);
			});
		}



	if ($('#page').hasClass('listeKlappbar')) {
			/* complex manager custom building themes*/
		if ($('.complex-list-wrapper').length) {
			$('.complex-unit-wrapper .table-responsive').slideUp(0);
			if ($('.complex-list-wrapper').length == 1) {
				$(this).find('.complex-unit-wrapper').addClass('active');
				$(this).find('.table-responsive').slideDown('fast');
			}
			$('.unit-title').on('click', function(){
				var $wrapper = $(this).closest('.complex-unit-wrapper');
				var $activeTable = $(this).find('.table-responsive');

				if ($wrapper.hasClass('active')) {
					$wrapper.removeClass('active');
					$wrapper.find('.table-responsive').slideUp('fast');
					$('.custom-graphic').each(function(index, el){
						var dataGraphic = $(el).data('graphic');
						if ($wrapper.find('.table-responsive').hasClass(dataGraphic)) {
							$(el).removeClass('activeGraphic');
						}
					});
				} else {
					$('.complex-unit-wrapper.active .table-responsive').slideUp('fast');
					$('.complex-unit-wrapper.active').removeClass('active');

					$wrapper.addClass('active');
					$wrapper.find('.table-responsive').slideDown('fast');

					$('.custom-graphic').each(function(index, el){
						var dataGraphic = $(el).data('graphic');
						if ($wrapper.find('.table-responsive').hasClass(dataGraphic)) {
							$('.custom-graphic').removeClass('activeGraphic');
							$(el).addClass('activeGraphic');
						}
					});
					
					
				}


			//to close open items in foreign groups
			if(!$('.complex-unit-header-row.active').closest('.complex-unit-wrapper').hasClass('active')){
				$('.complex-unit-header-row.active').trigger('click');
			};

			});

		//look for active items from complex manager and check if group needs to slide down
		function checkIfListGroupNeedsToOpen(){
			var curActiveOffer = $('.complex-unit-header-row.active');
			if (curActiveOffer[0]) {
			var curActiveOfferGroupParent = curActiveOffer.closest('.complex-unit-wrapper');
			if (curActiveOfferGroupParent[0] && !curActiveOfferGroupParent.hasClass('active')) {
				curActiveOfferGroupParent.find('.unit-title').trigger('click');
				$('html, body').animate({
					scrollTop: (($('.complex-unit-wrapper').first().offset().top) -100)
				}, 500, function(){

				});
			}
			}
		}
		window.setInterval(checkIfListGroupNeedsToOpen, 500);

		}
	}
	

	$(window).on('scroll', function(){
		var scrolled = $(window).scrollTop();
		var $header = $('#header');
		var $blocker = $('.blocker');
		if (scrolled > 50) {
			if (!$header.hasClass('scrolled')) {
				$header.addClass('scrolled');
				$blocker.addClass('scrolled');
			}
		} else if($header.hasClass('scrolled')) {
			$header.removeClass('scrolled');
			$blocker.removeClass('scrolled');
		}
	});

	//range slider
	rangeDropdownsToSlider();
	$('.casawp-filterform').on( "casawp-filterform:after-filter-reload", function(event, url, filteredUrl){
		console.log('hello world');
		rangeDropdownsToSlider();
	});

	function rangeDropdownsToSlider(){
		if($('.casawp-filterform-pricecount-2')){
			$('.casawp-filterform-pricecount-2').each(function(idx, priceWrapperElem){
				const $priceWrapperElem = $(priceWrapperElem);
				const $fromElem = $priceWrapperElem.find("select[name=price_from]");
				const $toElem = $priceWrapperElem.find("select[name=price_to]");
				if ($fromElem.length && $toElem.length) {
					let fromVal = $fromElem.find("option:first-child").val();
					if (!fromVal) {
						//the first item ist often a mask
						fromVal = $fromElem.find("option:nth-child(2)").val();
					}
					const toVal = $toElem.find("option:last-child").val();
					if (fromVal && toVal) {
						$fromElem.replaceWith('<input type="number" name="price_from" value="'+$fromElem.val()+'" />');
						$toElem.replaceWith('<input type="number" name="price_to" value="'+$toElem.val()+'" />');

						const values = $fromElem.find('option').map(function() { return ($(this).val() ? parseInt($(this).val()) : 0); }).get();
						let range = {};
						values.forEach((value, idx) => {
							if (idx === 0) {
								range.min = value;
							} else if((idx+1) === values.length){
								range.max = value;
							} else {
								range[(idx*(100/values.length))+"%"] = value;
							}
						});
						console.log(range);

						const $rFromElem = $priceWrapperElem.find("input[name=price_from]");
						const $rToElem = $priceWrapperElem.find("input[name=price_to]");

						$priceWrapperElem.find('div').not('.casawp-filterform-duo-label').hide();
						$priceWrapperElem.find('.casawp-filterform-duo-label').show();

						const $rangeSliderControl = $('<div class="form-control form-control-slider"><div class="noUi-placeholder" /></div>');
						$priceWrapperElem.append($rangeSliderControl);

						const sliderElem = $rangeSliderControl.find('.noUi-placeholder')[0];


						noUiSlider.create(sliderElem, {
							start: [
								(parseInt($fromElem.val()) ? parseInt($fromElem.val()) : 0),
								(parseInt($toElem.val()) ? parseInt($toElem.val()) : toVal)
							],
							connect: true,
							snap: true,
							range: range,
							pips: {
								mode: 'positions',
								values: [0,50,100],
								density: 3,
								// filter: ( value, type ) => {
								// 	return value % 1000 ? 2 : 1;
								// },
								format: wNumb({
									decimals: 0,
									prefix: 'CHF ',
									thousand: '\'',
								}),
								stepped: true,
							}

						});

						sliderElem.noUiSlider.on('change', ( values, handle ) => {
							var value = values[handle];

							if ( handle === 0 ) {
								$rFromElem.val(Math.round(parseInt(value)));
							} else {
								$rToElem.val(Math.round(parseInt(value)));
							}

							$('.casawp-filterform').trigger('change');
						});
					}
				}
			})
		}
	}


	var $targetElementData = $('.casawp-legal__page.casawp-legal__page--terms');
	if ($targetElementData.length) {
	  $targetElementData.hide();

	  var $loadingIndicator = $('<div id="spinnerResults" class="spinner-outer"><svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg></div>');
	  $targetElementData.before($loadingIndicator);

	  fetch('https://cron.naef.ch/politique-de-confidentialite/', {
		method: 'GET',
		headers: {
		  'X-Custom-CORS': 'NAEF_CUSTOM_CORS',
		  'Content-Type': 'text/plain'
		}
	  })
	  .then(function(response) {
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}
		return response.text();
	  })
	  .then(function(html) {
		var parser = new DOMParser();
		var doc = parser.parseFromString(html, 'text/html');
		var remoteContent = doc.querySelector('.wpb_text_column.wpb_content_element');

		if (remoteContent) {
		  $targetElementData.html(remoteContent.innerHTML);

		  $targetElementData.show();
		  $loadingIndicator.remove();
		}
	  })
	  .catch(function(error) {
		console.error('Error fetching data protection content:', error);
		$loadingIndicator.text('Error fetching content.');
	  });
	}

	var $targetElement = $('.casawp-legal__page.casawp-legal__page--imprint');
	if ($targetElement.length) {
	  $targetElement.hide();

	  var $loadingIndicator = $('<div id="spinnerResults" class="spinner-outer"><svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg></div>');
	  $targetElement.before($loadingIndicator);

	  fetch('https://cron.naef.ch/mentions-legales/', {
		method: 'GET',
		headers: {
		  'X-Custom-CORS': 'NAEF_CUSTOM_CORS',
		  'Content-Type': 'text/plain'
		}
	  })
	  .then(function(response) {
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}
		return response.text();
	  })
	  .then(function(html) {
		var parser = new DOMParser();
		var doc = parser.parseFromString(html, 'text/html');
		var remoteContent = doc.querySelector('.wpb_text_column.wpb_content_element');

		if (remoteContent) {
		  $targetElement.html(remoteContent.innerHTML);

		  $targetElement.show();
		  $loadingIndicator.remove();
		}
	  })
	  .catch(function(error) {
		console.error('Error fetching data protection content:', error);
		$loadingIndicator.text('Error fetching content.');
	  });
	}

});




// WEBPACK FOOTER //
// ./src/js/main.js